/* 🤖 this file was generated by svg-to-ts */
export const iconUsdt0: {
  name: 'usdt_0';
  data: string;
} = {
  name: 'usdt_0',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><g clip-path="url(#usd-0__clip0_2388_5)"><path fill="#00B988" fill-rule="evenodd" d="M32 15.994c0 8.827-7.164 15.983-16 15.983S.001 24.82.001 15.994 7.164.012 16.001.012c8.835 0 15.998 7.155 15.998 15.982M7.818 7.64H24.18v3.632h-6.363v3.632h-3.636v-3.632H7.82zm6.363 14.53h-3.636v-7.266h3.636zm3.637 0v3.63h-3.636v-3.63zm0 0h3.635v-7.266h-3.636z" clip-rule="evenodd"/></g><defs><clipPath id="usd-0__clip0_2388_5"><path fill="#fff" d="M0 0h32v32H0z"/></clipPath></defs></svg>`,
};
